// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
  width: 100%;
  overflow-x: auto;
}

table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.form-container {
  border: 1px solid #d3d3d3;
  padding: 20px;
  max-width: 100%;
  margin: 3% 0%;
  border-radius: 1px;
}
.form-group {
  margin-right: 10px;
}

.small-dropdown {
  width: 150px;
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th,
td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}

table th {
  background-color: #0b2d71;
  color: white;
  font-weight: bold;
}

td a {
  color: blue;
  text-decoration: none;
  /* Optional: remove underline */
}

td a:hover {
  text-decoration: underline;
  /* Optional: add underline on hover */
}

.label {
  margin-left: 40px;
}

.label-enddate {
  margin-left: 90px;
}

.label-startdate {
  margin-left: 90px;
}

#submit {
  margin-left: 100px;

}

.title {
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: center;
  font-size: 100%;
}

.title h2 {
  color: #0b2d71 !important;
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.label-spacing {
  margin-right: 10px;
}
.error-message {
  color: red;
  font-weight: bold;
  margin-top: 10px;
}
.title h3 {
  color: white !important;
  text-align: left;
  margin-top: auto;
  margin-bottom: auto;
  }
  .move-up {
    margin-top: 10px; /* Adjust the value as needed */
  }


`, "",{"version":3,"sources":["webpack://./src/app/modules/temporaryredelegation/payrolldownload/payrolldownload.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;AAEpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB;EACA;IACE,gBAAgB,EAAE,+BAA+B;EACnD","sourcesContent":[".table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth,\ntd {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.form-container {\n  border: 1px solid #d3d3d3;\n  padding: 20px;\n  max-width: 100%;\n  margin: 3% 0%;\n  border-radius: 1px;\n}\n.form-group {\n  margin-right: 10px;\n}\n\n.small-dropdown {\n  width: 150px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\nth,\ntd {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n\ntable th {\n  background-color: #0b2d71;\n  color: white;\n  font-weight: bold;\n}\n\ntd a {\n  color: blue;\n  text-decoration: none;\n  /* Optional: remove underline */\n}\n\ntd a:hover {\n  text-decoration: underline;\n  /* Optional: add underline on hover */\n}\n\n.label {\n  margin-left: 40px;\n}\n\n.label-enddate {\n  margin-left: 90px;\n}\n\n.label-startdate {\n  margin-left: 90px;\n}\n\n#submit {\n  margin-left: 100px;\n\n}\n\n.title {\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: center;\n  font-size: 100%;\n}\n\n.title h2 {\n  color: #0b2d71 !important;\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.label-spacing {\n  margin-right: 10px;\n}\n.error-message {\n  color: red;\n  font-weight: bold;\n  margin-top: 10px;\n}\n.title h3 {\n  color: white !important;\n  text-align: left;\n  margin-top: auto;\n  margin-bottom: auto;\n  }\n  .move-up {\n    margin-top: 10px; /* Adjust the value as needed */\n  }\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
